





















































import { Component, Prop, Vue } from "vue-property-decorator";
import ControlPanelSwitcher from "@share/web-conferences/components/control-panel/ControlPanelSwitcher.vue";
import MicIcon from '../../../../assets/svg/mic.svg';
import CameraIcon from '../../../../assets/svg/wc-camera.svg';
import ControlPanelLeave from "@share/web-conferences/components/control-panel/ControlPanelLeave.vue";
import ControlPanelTimer from "@share/web-conferences/components/control-panel/ControlPanelTimer.vue";
import QualityIndicator from "@share/live-kit/components/common/QualityIndicator.vue";
import {Meeting} from "@api/models/meetings/Meeting";
import {Element} from "@api/models/Element";
import {DateTime} from "luxon";
import {isPresenter as isPresenterHelper} from "@share/web-conferences/helpers/UserRoleHelper";
import DeviceButton from "@share/live-kit/components/devices/DeviceButton.vue";
import ControlPanelShare from "@share/live-kit/components/control-panel/ControlPanelShare.vue";
import HandIcon from '../../../../assets/svg/web-conferences/hand.svg';
import {raisedHandUsersGetter} from "@share/web-conferences/store/getters";
import {UserProfile} from "@api/models/UserProfile";
import {TooltipDirective} from "@share/directives/Tooltip";
import {WebConferenceService} from "@share/web-conferences/data/WebConferenceService";
import {SpeakerChecker} from "@share/web-conferences/helpers/SpeakerChecker";
import {isSchemaMeeting, isSchemaMeetingSchedule} from "@share/web-conferences/helpers/isSchemaMeeting";
import { WebConferenceRepository } from "@api/repositories/WebConferenceRepository";
import { RepositoryFabric } from "@api/repositories/RepositoryFabric";
import { RouteNamesEnum } from "@service/router/RouteNamesEnum";
import { LiveKItJoinHandlerInterface } from "@share/live-kit/interfaces/LiveKItJoinHandlerInterface";
import { LiveKitClientInterface } from "@share/live-kit/interfaces/LiveKitClientInterface";
import { ControlPanelControllerInterface } from "@share/live-kit/interfaces/ControlPanelControllerInterface";
import RecordingButton from "@share/common/recording-button/RecordingButton.vue";
import { RecordingController } from "@share/web-conferences/helpers/RecordingController";
import { LiveKitQualityController } from "@share/live-kit/controllers/LiveKitQualityController";

@Component({
  name: "ControlPanel",
  components: {
      RecordingButton,
    ControlPanelShare, QualityIndicator,
    DeviceButton, ControlPanelTimer, ControlPanelLeave,
    ControlPanelSwitcher, MicIcon, CameraIcon, HandIcon
  },
  directives: {TooltipDirective}
})
export default class ControlPanel extends Vue {
  @Prop({required: true}) element: Meeting | Element;
  @Prop({required: true}) schemaId: string;
  @Prop({required: true}) stateKey: string;
  @Prop({required: true}) joinHandler: LiveKItJoinHandlerInterface;
  @Prop({ default: true }) needHandRaiseButton: boolean;
  @Prop({ default: false }) needLiveSwitcher: boolean;
  @Prop({required: true}) webConferenceService: WebConferenceService;
  @Prop({required: true}) speakerChecker: SpeakerChecker;
  @Prop( {required: true} ) client: LiveKitClientInterface;
  @Prop({ required: true }) controller: ControlPanelControllerInterface;
  @Prop({ required: true }) recordingController: RecordingController;
  @Prop({required: true}) qualityController: LiveKitQualityController;
  // @Prop({required: true}) networkQuality: AgoraNetworkQualityInterface | null;

  emptyVideoDevices = false;
  emptyMicDevices = false;

  webConferenceRepository: WebConferenceRepository = this.$repositories.get(RepositoryFabric.WEB_CONFERENCE);

  get beginAt(): DateTime | null {
    return this.element?.beginAt ?? null;
  }

  get endAt(): DateTime | null {
    return this.element?.endAt ?? null;
  }

  get isPresenter(): boolean {
    return !!this.joinHandler.webConferenceData
           && isPresenterHelper(this.joinHandler.webConferenceData.userRole);
  }

  get currentUserProfile(): UserProfile {
    return this.$store.getters.profile;
  }

  get isSharing() {
    return this.webConferenceService.webConferenceData?.isSharingUser(this.currentUserProfile.userId as number);
  }

  get isThereSharingUser() {
    return !this.isSharing && this.webConferenceService.webConferenceData?.isSharing();
  }

  get isUsingProxy() {
      return false;
  }

  get proxyTooltipProps() {
      return {
        subtitle: this.$t('web-conferences.usingProxyTooltip'),
        isCentered: true
      };
  }

  get isAdmin() {
    return this.$store.getters.isAdmin;
  }

  get isMeeting() {
      return isSchemaMeeting(this.schemaId);
  }

  get isMeetingSchedule() {
      return isSchemaMeetingSchedule(this.schemaId);
  }

  get isOriginalSpeaker() {
      return this.speakerChecker.isInOriginalSpeakersList(this.currentUserProfile.userId as number) || this.isAdmin;
  }

  get canShare() {
      return this.isMeeting || this.isPresenter;//(this.isPresenter && this.isOriginalSpeaker);
  }

  get canSharePdf() {
      return this.isMeetingSchedule ? this.isOriginalSpeaker : this.canShare;
  }
  
  get quality() {
    return this.qualityController.localUserQuality();
    // return (this.isPresenter ? this.networkQuality?.uplinkNetworkQuality : this.networkQuality?.downlinkNetworkQuality) || 0
  }

  get hasQuality() {
      return this.qualityController.hasLocalQuality();
  }

  get isPublicMeeting() {
    return this.$route.name == RouteNamesEnum.viewMeetingPublic;
  }

  mounted() {
    this.setHandState();
  }

  omMicIsOnChange() {
    this.$emit('switchMic', this.joinHandler.client.micIsOn);
  }

  omVideoIsOnChange() {
    this.$emit('switchVideo', this.joinHandler.client.videoIsOn);
  }

  setHandState() {
    this.joinHandler.webConferenceService.handIsRaised = (this.$store.getters[raisedHandUsersGetter](this.stateKey) ?? []).findIndex((item: UserProfile) => item.userId == this.currentUserProfile.userId) >= 0;
  }

  async toggleLiveState() {
    try {
      if (!this.isPresenter) {
        await this.webConferenceRepository.addPresenter(this.schemaId, this.element.id, this.currentUserProfile.userId as number);
      } else {
        await this.webConferenceRepository.deletePresenter(this.schemaId, this.element.id, this.currentUserProfile.userId as number);
      }
    }
    catch(e) {
      this.$store.dispatch('reportError', e);
    }
  }

  async onHandIsRaised() {
    this.joinHandler.webConferenceService.handIsRaised ? await this.joinHandler.webConferenceService.raiseHand() : await this.joinHandler.webConferenceService.lowerHand();
  }

  onLeave() {
    this.$emit('leave');
  }

  onDevicesChanged(devices: [MediaDeviceInfo[], MediaDeviceInfo[]]) {
    this.emptyVideoDevices = !(devices && devices.length && devices[0].length > 0);
    this.emptyMicDevices = !(devices && devices.length && devices[1].length > 0);
  }
}
